var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTransferwiseMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "39px",
    viewBox: "0 0 36 39",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-1364.000000, -6244.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(1324.000000, 6206.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "44.6960977 38.2978723 50.6496873 48.287988 40.212766 58.2666472 58.2568396 58.2666472 59.9524097 54.2683096 49.9966637 54.2683096 56.0189926 48.2612561 52.5018303 42.2923911 68.9190732 42.2923911 54.5067274 76.4138298 59.4445024 76.4138298 75.560056 38.2978723"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTransferwiseMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/transferwise-mark.d0e7118a.svg";
export { ForwardRef as ReactComponent };